import * as React from 'react';

type UseToggleAdaResult = {
    adaEnabled: boolean;
    toggle: () => void;
};

export default function useToggleAda(): UseToggleAdaResult {
    const [adaEnabled, setAdaEnabled] = React.useState(false);
    const stopCounter = React.useRef(20);

    React.useEffect(() => {
        const checkAdaReady = () => {
            if (window?.adaEmbed?.toggle) {
                setAdaEnabled(true);
            } else if (stopCounter.current > 0) {
                stopCounter.current--;
                setTimeout(() => {
                    checkAdaReady();
                }, 500);
            }
        };

        checkAdaReady();
    }, []);

    const toggle = () => {
        if (window?.adaEmbed?.toggle) {
            window.adaEmbed.toggle();
        }
    };

    return {
        adaEnabled,
        toggle,
    };
}
